import React from 'react';
import { VisibleCol } from '../types';

export interface UseExportProps {
  csvEnabled: boolean;
  visibleCols: VisibleCol[];
  csvData?: any[];
  csvAccessors?: Record<string, (item: any) => string | number | null | undefined>;
  tableId?: string;
  csvFilename?: string;
}
export const useExport = ({ csvEnabled, csvData, csvAccessors, tableId, visibleCols, csvFilename }: UseExportProps) => {
  const csvDataRef = React.useRef(csvData);
  const csvAccessorsRef = React.useRef(csvAccessors);
  const visibleColsRef = React.useRef(visibleCols);
  const tableIdRef = React.useRef(tableId);
  const csvFilenameRef = React.useRef(csvFilename);

  React.useEffect(() => {
    csvDataRef.current = csvData;
    csvAccessorsRef.current = csvAccessors;
    visibleColsRef.current = visibleCols;
    tableIdRef.current = tableId;
    csvFilenameRef.current = csvFilename;
  }, [csvData, csvAccessors, visibleCols, tableId, csvFilename]);

  const handleExport = () => {
    if (!csvEnabled) return;

    const escapeChars = (input: string | number | null | undefined) => {
      const string = input == null ? '' : String(input);
      return /[",\r\n]/.test(string) ? `"${string.replace(/"/g, '""')}"` : string;
    };

    const cols = visibleColsRef.current;
    const data = csvDataRef.current!;
    const accessors = csvAccessorsRef.current!;

    const headers = cols.map((c) => escapeChars(c.label));
    const body = data.map((item) => cols.map((c) => escapeChars(accessors[c.id]?.(item))));
    const csv = '\uFEFF' + [headers, ...body].map((line) => line.join(',')).join('\r\n');
    const filename =
      csvFilenameRef.current ?? `${tableIdRef.current ?? 'table'}-${new Date().toISOString().slice(0, 10)}.csv`;

    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    setTimeout(() => URL.revokeObjectURL(url), 0);
  };

  return handleExport;
};
